<template>
  <div id="menu-tree">
    <transition>
      <div id="home-aside" v-if="$store.getters.Menus.length>0" >
        <el-menu style="height: 100%;" default-active="2" class="el-menu-vertical-demo" background-color="#323438" text-color="#fff" :unique-opened="true" active-text-color="#ffd04b" :collapse="!$store.getters.menuType">
          <div id="aside-logo">
            <img v-if="$store.getters.menuType" src="../assets/img/logo_white.png" />
            <img v-if="!$store.getters.menuType" src="../assets/img/logo_only.png" />
          </div>
          <el-submenu index="x-x">
            
            <template slot="title">
              <font-awesome-icon icon="camera" style="padding-left:5px;padding-right:10px;" />
              <span >我的菜单</span>
            </template>          
            <div  v-for="(menuMe, n) in $store.getters.MenusMe" v-bind:key="menuMe.menuId">
              <el-menu-item class="aside-threemenu" @click="openItem" :index="menuMe.menuLinkpage"  ><span>{{ menuMe.menuName }}</span><i @click.stop="delMenusMe" :id="menuMe.menuId" class="aside-threemenu-ico el-icon-star-on" title="取消收藏"></i></el-menu-item>
            </div>          
          </el-submenu>
          <el-submenu :class="i==$store.getters.Menus[$store.getters.MenuNum].childMenu.length-1 ?  'max-height' : ''" :index="i + '-' + i" v-for="(childTwo,i) in $store.getters.Menus[$store.getters.MenuNum].childMenu" v-bind:key="childTwo.menuId">
            <template slot="title">
              <font-awesome-icon :icon="childTwo.menuImg" style="padding-left:5px;padding-right:10px;" />
              <span v-if="$store.getters.menuType">{{ childTwo.menuName }}</span>
            </template>
            <div v-for="(childThree, n) in childTwo.childMenu" v-bind:key="childThree.menuId">
              <el-menu-item class="aside-threemenu" @click="openItem" :index="childThree.menuLinkpage"  ><span>{{ childThree.menuName }}</span><i @click.stop="saveMenusMe" :id="childThree.menuId" v-if="childThree.menuMe=='0'" class="aside-threemenu-ico el-icon-star-off" title="添加至我的菜单"></i><i @click.stop="saveMenusMe" v-if="childThree.menuMe=='1'" :id="childThree.menuId" class="aside-threemenu-ico el-icon-star-on" title="添加至我的菜单"></i></el-menu-item>
            </div>          
          </el-submenu>
        
          <div id="aside-firstmenu" >
            <div class="level-one" v-popover:p1 v-if="$store.getters.Menus.length>1 && !$store.getters.menuType" >
              <el-popover ref="p1" popper-class="level-one-min-more" placement="right-end" :visible-arrow="false" trigger="hover">
                <div class="level-one-more" v-for="(Menu,i) in $store.getters.Menus" style="height: 30px;hover{cursor: pointer};" @click="openFirstMenu" :id="i" :key="Menu.MenuId">
                  <font-awesome-icon :icon="Menu.menuImg" style="padding-right:10px;width:20px;" />
                  <span>{{Menu.menuName}}</span>
                </div>                
              </el-popover>
              <font-awesome-icon  icon="ellipsis-h" title="更多" />
            </div>
            <div class="level-one" v-if="((i<3 && $store.getters.Menus.length>4) || (i<4 && $store.getters.Menus.length<=4)) && $store.getters.menuType" v-for="(Menu,i) in $store.getters.Menus" :key="Menu.MenuId">
              <font-awesome-icon @click="openFirstMenu" :id="i" v-if="i<3 && $store.getters.Menus.length>1" :icon="Menu.menuImg" :title="Menu.menuName"/>
              <font-awesome-icon @click="openFirstMenu" :id="i" v-if="i==3 && $store.getters.Menus.length==4" :icon="Menu.menuImg" :title="Menu.menuName"/>
            </div>          
            <div class="level-one" v-popover:p2 v-if="$store.getters.Menus.length>4 && $store.getters.menuType" >
              <el-popover ref="p2" popper-class="level-one-max-more" placement="right-end" :visible-arrow="false" trigger="hover">
                <div class="level-one-more" v-for="(Menu,i) in $store.getters.Menus" style="height: 30px;hover{cursor: pointer};" @click="openFirstMenu" :id="i" v-if="i>=3 && $store.getters.Menus.length>4" :key="Menu.MenuId">
                  <font-awesome-icon :icon="Menu.menuImg" style="padding-right:10px;width:20px;" />
                  {{Menu.menuName}}
                </div>                
              </el-popover>
              <font-awesome-icon icon="ellipsis-h" title="更多" />
            </div>
          </div>
        </el-menu>       
      </div>
    </transition>
    
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import store from "@/store";
export default {
  created() {
    this.getMenus();
  },
  methods: {
    ...mapActions([     
      'getMenus',
      'saveMenuMe',
      'delMenuMe'
    ]),
    openFirstMenu(event) {
      if (event.currentTarget.id != "999" && store.getters.MenuNum != event.currentTarget.id) {
        store.commit('SET_MENU_NUM',event.currentTarget.id)
      }
    },
    openItem(e) {
      //console.log(e.index);
      store.commit('SET_PAGE_NAME',e.index)
    },
    saveMenusMe(e) {
      //console.log(e.currentTarget.id)
      this.saveMenuMe(e.currentTarget.id)
    },
    delMenusMe(e) {
      //console.log(e.currentTarget.id)
      this.delMenuMe(e.currentTarget.id)
    } 

  }
};
</script>
<style scoped lang="scss">
#menu-tree {
  display: flex;
  flex-direction: row;
  .el-menu-vertical-demo:not(.el-menu--collapse){
    width: 220px;
  }
  .el-menu-vertical-demo {    
    min-height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }  
}
.max-height{
  flex: 1 1 auto;
}
.level-one-max-more{
  transform:translateX(200px);
}
#home-aside {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  background: #323438;
  #aside-logo {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 140px;
  }
  #menusme {
    padding-left:50px;
  }
  
  #aside-firstmenu {
    height: 80px;
    width: 100%;
    background: #323438;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    .level-one-more{
      padding-top: 10px;
      padding-bottom: 10px;      
    }
    .level-one > * {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      font-size: 22px;
      color: #ffffff;
    }
    .level-one > *:hover {
      cursor: pointer;
      font-size: 26px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/MenuTree.vue